import { connect } from 'react-redux';

const mapStateToProps = () => ({
  categories: {
    header: {
      row: {
        selectable: true,
      },
      cells: [
        {
          id: 1,
          type: 'sortable',
          direction: 'desc',
          text: 'Category Description',
          key: 'categoryDescription',
        },
        {
          id: 2,
          type: 'sortable',
          direction: 'desc',
          text: 'Category Code',
          key: 'categoryCode',
        },
        {
          id: 3,
          type: 'sortable',
          direction: 'desc',
          text: 'CPD Module Title',
          key: 'cpdCourse',
        },
      ],

    },
  },
});

export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
